import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../../Components/Button';
import './VideoAnima.scss';
import { FaRegPlayCircle } from 'react-icons/fa';

// IDs do YouTube para os vídeos
const youtubeUrlInstitucional = "https://www.youtube.com/embed/Ca0rBt5Bc28";
const youtubeUrlManifesto = "https://www.youtube.com/embed/qpqSEgt5tpI";

const VideoAnima = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const videoWrapperRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (videoWrapperRef.current) {
      observer.observe(videoWrapperRef.current);
    }

    return () => {
      if (videoWrapperRef.current) {
        observer.unobserve(videoWrapperRef.current);
      }
    };
  }, []);

  const handleSobreClick = () => {
    window.open('/sobre', '_self');
  };

  const getYoutubeEmbed = (url) => {
    return (
      <iframe
        width="100%"
        height="500"
        src={url + '?rel=0&autoplay=0&mute=1&controls=1'}
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    );
  };

  return (
    <section className='videoAnima'>
      {location.pathname === '/sobre' ? (
        <>
          <h1>O que é ser Prime?</h1>
          <div><p>Assista ao nosso Vídeo Institucional</p></div>
          <div className='lineChama'></div>
          <div className='video-container'>
            <div className="video-wrapper" ref={videoWrapperRef}>
              {isVisible && getYoutubeEmbed(youtubeUrlManifesto)}
            </div>
          </div>
        </>
      ) : (
        <>
          <h1>O Melhor da Pizza</h1>
          <div><p>Vem de Prime</p></div>
          <div className='lineChama'></div>
          <div className='video-container'>
            <div className="video-wrapper" ref={videoWrapperRef}>
              {isVisible && getYoutubeEmbed(youtubeUrlInstitucional)}
            </div>
          </div>
          <div className='lineChama'></div>
          <div>
            <Button onClick={handleSobreClick} type="pizzaprime-red" size="large-rounded">
              Saiba mais sobre a nossa história
            </Button>
          </div>
          <div className='lineChama' style={{ height: '50px' }}></div>
          <div>ou</div>
          <div className='lineChama' style={{ height: '50px' }}></div>
          <div><p>Aproveite as nossas ofertas</p></div>
        </>
      )}
    </section>
  );
};

export default VideoAnima;
